import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Letter } from '@schoolbelle/api/letter';
import { flatten, max, min, groupBy, keys, times } from 'lodash-es';
import { LetterReadTableService, ReadAnswerInfo, ReadTableRowData } from '@schoolbelle/api/letter-read';

@Component({
  selector: 'app-bar-chart-read',
  templateUrl: './bar-chart-read.component.html',
  styleUrls: ['./bar-chart-read.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class BarChartReadComponent implements OnInit {
  type = 'read'
  _rows:ReadTableRowData[] = []
  @Input() letter:Partial<Letter>;
  @Input() set rows(v:ReadTableRowData[]) {
    if (this._rows === v) return;
    this._rows = v;
    if (this.letter) this.refresh();
  }
  get rows () {
    return this._rows;
  };
  constructor(
    protected letterRead:LetterReadTableService,
    protected cdRef:ChangeDetectorRef,

  ) {
    
  }

  getChartData () {
    const type = this.type;
    let max_hour:number, ts_list:number[],unit:number, grouped:{[key:string]:number[]};
    const oneHour = 60 * 60 * 1000;
    ts_list = flatten(this.rows.map(v=>this.letterRead.getTimestampFromMultipleReadStatuses(v.slice(3) as any[], type as any))).filter(v=>v);
    unit = (max(ts_list) - this.letter.created_at) / 24;
    unit = Math.ceil(unit / oneHour);
    if (1 < unit && unit < 3) unit = 3;
    else if (3 < unit && unit < 6) unit = 6;
    else if (6 < unit && unit < 12) unit = 12;
    else if (12 < unit && unit < 24) unit = 24;
    else if (unit > 24) unit = Math.ceil(unit/24) * 24;
    unit = unit * oneHour;

    grouped = groupBy(ts_list, (ts)=>Math.ceil((ts - this.letter.created_at) / unit))


    max_hour = max(keys(grouped).map(k=>Number(k)));
    if (max_hour < 24) max_hour = 24;

    const data = times(max_hour).map(i=>i+1).map(i=>{
      let name = '';
      let hours = i * unit/oneHour;
      let h = hours %24, d = Math.floor(hours/24);
      if (d) name += `${d}d`;
      if (d && h) name +=  ` `;
      if (h) name += `${h}hr`;
      
      return {
        name,
        "value":grouped[i] ? grouped[i].length : 0,
      }
    })
    return data;
  }
  refresh () {
    this.single = this.getChartData();
    this.cdRef.detectChanges();
  }
  ngOnInit () {
    this.refresh();
  }

  single: any[] = [];
  view = [700, 170];
  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  // xAxisLabel = "Country";
  showYAxisLabel = false;
  // yAxisLabel = "Population";

  colorScheme = {
    domain: ["#F96E32"]
  };  
  axisFormat(val) {
    if (val % 1 === 0) {
      return val.toLocaleString();
    } else {
      return '';
    }  
  }  
}    